export const USER_TYPES = [
	{
        "userTypesId": 4152,
        "userTypesName": "PmdUser"
    },
	{
        "userTypesId": 4153,
        "userTypesName": "PortalUser"
    },
]